<template>
  <Transition name="mini-cart" appear>
    <slot />
  </Transition>
</template>
<style lang="scss">
  .mini-cart-enter-active {
    transition: transform $transition-time-in $transition-ease-in;
  }

  .mini-cart-leave-active {
    transition: transform $transition-time-out $transition-ease-out;
  }

  .mini-cart-enter-from,
  .mini-cart-leave-to {
    transform: translateX(105%);
  }

  .mini-cart-leave-from,
  .mini-cart-enter-to {
    transform: translateX(0);
  }
</style>
